import { Breadcrumbs, searchToQuery } from "@sembark-travel/ui/router"
import { useParams } from "../../../../../../../../../../router"
import { useLocation } from "react-router"
import { Helmet } from "react-helmet-async"
import { generatePath } from "../../../../../../../../../../router-utils"
import { TSPFileEditForm } from "../../../../../../../../../../DataDrive/TransportService"

export default function TransportServicePricesEditPage() {
	const location = useLocation()
	const { folderId, fileId, versionId } = useParams(
		"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/edit/transport"
	)
	const query = searchToQuery<{
		file: string
		folder: string
	}>(location && location.search)

	const fileName = query["file"] || ""
	const folderName = query["folder"] || ""

	return (
		<>
			<Helmet>
				<title>Edit Transport Service Prices</title>
			</Helmet>
			<Breadcrumbs
				key={"Edit Transport Service Prices"}
				title="Edit Transport Service Prices"
				items={[
					[generatePath("/data-drive"), "Transportation Prices"],
					[
						generatePath("/data-drive/folders/:folderId/files/:fileId", {
							folderId,
							fileId,
						}),
						folderName,
					],
					[
						generatePath(
							"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view",
							{
								folderId,
								fileId,
								versionId,
							}
						),
						fileName,
					],
				]}
			/>
			<TSPFileEditForm
				folderId={folderId}
				fileId={fileId}
				versionId={versionId}
			/>
		</>
	)
}
